<template>
  <div>
    <header @click="expanded = !expanded" class="categories__header" :class="{ expanded }">
      <h2 class="categories__title">Categories</h2>
    </header>
    <ul class="categories__list" :class="{ expanded }">
      <li v-if="favorites.length" class="categories__item" :class="{'categories__item--current':'favorites' == obj.selected}">
        <router-link class="categories__link" :class="{'categories__link--current':'favorites' == obj.selected}" v-on:click.native="obj.selected = 'favorites'" :to="{ name: 'Category', params: {id: 'favorites'}}">Favorites</router-link>
      </li>
      <li v-if="customFormats.length" class="categories__item" :class="{'categories__item--current':'custom' == obj.selected}">
        <router-link class="categories__link" :class="{'categories__link--current':'custom' == obj.selected}" v-on:click.native="obj.selected = 'custom'" :to="{ name: 'Category', params: {id: 'custom'}}">{{ getCustomName }}</router-link>
      </li>
      <li v-if="userIsAdmin" class="categories__item" :class="{'categories__item--current':'invisible' == obj.selected}">
        <router-link class="categories__link" :class="{'categories__link--current':'invisible' == obj.selected}" v-on:click.native="obj.selected = 'invisible'" :to="{ name: 'Category', params: {id: 'invisible'}}">Non-Public Ads</router-link>
      </li>
      <li class="categories__item" :class="{'categories__item--current':'recent' == obj.selected}" v-if="recentCount">
        <router-link class="categories__link" :class="{'categories__link--current':'recent' == obj.selected}" v-on:click.native="obj.selected = 'recent'" :to="{ name: 'Category', params: {id: 'recent'}}">Recently Released {{ recentCount }}</router-link>
      </li>
      <li class="categories__item" v-for="category in categories" :key="category.id" :class="{'categories__item--current':category.id == obj.selected}">
        <router-link class="categories__link" :class="{'categories__link--current':category.id == obj.selected}" v-on:click.native="obj.selected = category.id" :to="{ name: 'Category', params: {id: category.id}}">{{ category.name }}</router-link>
      </li>
      <!-- This was taken out because it is working as the "Most Popular" Category which is already from the database
      <li class="categories__item categories__item&#45;&#45;current"><a href="categories/1" class="categories__link categories__link&#45;&#45;current">Park Beta Formats (Exclusive)</a></li>-->

    </ul>
  </div>
</template>

<script>
import {mapState} from 'vuex'

export default {
  name: 'categories-listing',
  data () {
    return {
      obj: {
        selected: undefined
      },
      expanded: false
    }
  },
  computed: {
    ...mapState('categories', ['categories']),
    ...mapState('users', ['favorites']),
    ...mapState(['account']),
    customFormats() {
      return this.$store.getters['formats/custom']
    },
    recentCount () {
      let counter = null;
      let formats = this.$store.getters['formats/formats']
      if (formats) {
        formats.forEach(format => {
          let today = new Date();
          if (new Date(format.updated_at) > new Date().setDate(today.getDate()-30)) {
            counter++;
          }
        })
      }
      return counter ? '(' + counter + ')' : null
    },
    userIsAdmin() {
      return this.$store.state.me.admin || this.$store.state.me.format_admin
    },
    getCustomName() {
      return this.account.name + ' Premium'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/CategoriesListing.vue